export const SHOWROOM = {
  address: "7/24 Prebble Street, Rochedale QLD 4123",
  mapsHref: "https://www.google.com/maps/search/?api=1&query=7%2F24+Prebble+Street+Rochedale+QLD+4123",
  mapEmbed: "https://www.google.com/maps?q=7%2F24+Prebble+Street+Rochedale+QLD+4123&z=15&output=embed",
  phone: "07 2142 2278",
  phoneHref: "tel:+61721422278",
  hours: "Monday – Friday, 9am – 5pm",
  email: "sales@sterlingjoinery.com.au",
};
